/**
 * Feature Announcements Configuration
 * 
 * HOW TO ADD A NEW ANNOUNCEMENT:
 * 1. Add a new object to the announcements array
 * 2. Change the 'id' to a unique value (use current date for uniqueness)
 * 3. Update title, message, and features
 * 4. Set type: 'info' (blue), 'success' (green), or 'warning' (yellow)
 * 5. The banner will automatically show to all users who haven't dismissed it
 * 
 * IMPORTANT: Only the FIRST announcement in the array will be shown.
 * Move older announcements down or remove them.
 */

export const announcements = [
  {
    id: 'feature-announcement-2026-02-15', // MUST be unique for each announcement
    title: 'New Features Available! 🎉',
    message: 'We\'ve added powerful new features to improve your experience.',
    features: [
      { text: 'PDF Export for Meeting Minutes', link: '/meetings' },
      { text: 'Rich Text Editors for Better Formatting', link: '/meetings' },
      { text: 'In-App Notifications System', link: '/notifications' }
    ],
    type: 'info', // 'info' (blue), 'success' (green), 'warning' (yellow)
    showCTA: true,
    ctaText: 'Explore Features',
    ctaLink: '/meetings'
  },
  
  // Example of a success announcement (commented out)
  // {
  //   id: 'feature-announcement-2026-02-20',
  //   title: 'System Upgrade Complete! ✅',
  //   message: 'We\'ve successfully upgraded our infrastructure for better performance.',
  //   features: [
  //     { text: 'Faster Page Load Times', link: '/dashboard' },
  //     { text: 'Improved Reliability', link: '/dashboard' }
  //   ],
  //   type: 'success',
  //   showCTA: false
  // },
  
  // Example of a warning announcement (commented out)
  // {
  //   id: 'feature-announcement-2026-02-25',
  //   title: 'Scheduled Maintenance',
  //   message: 'System maintenance scheduled for Feb 28, 2026 from 2:00 AM - 4:00 AM EAT.',
  //   features: [],
  //   type: 'warning',
  //   showCTA: true,
  //   ctaText: 'Learn More',
  //   ctaLink: '/settings'
  // }
];

// Get the current active announcement (first one in the array)
export const getCurrentAnnouncement = () => {
  return announcements.length > 0 ? announcements[0] : null;
};
